import { render, staticRenderFns } from "./IconsPagesProjects.vue?vue&type=template&id=1a88aaf6&scoped=true&"
import script from "./IconsPagesProjects.vue?vue&type=script&lang=js&"
export * from "./IconsPagesProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a88aaf6",
  null
  
)

export default component.exports